import React, { useEffect, useReducer, useState } from 'react';
import CallOut from '../components/Common/CallOut';
import Notification from '../components/Common/Notification';
import ActivityLoader from '../components/Common/ActivityLoader';
import TextInput from '../components/Common/TextInput';
import { useAccounts } from '../DataStore/AccountsContext';
import ajaxAccountChart from '../util/remote/ajaxAccountChart';
import { useTheme } from '../DataStore/ThemeContext';

const reducer = (state, action) => {
  if (action.type === "RESET") {
    return {
      ...state,
      accountTitle: initialState.accountTitle,
      accountDescription: initialState.accountDescription
    };
  }
  return { ...state, [action.type]: action.value };
};

const initialState = {
  accountNumber: "",
  accountTitle: "",
  accountDescription: "",
  accountCategory: {},
  isSubAccount: false,
  parentAccount: {},
  accountListing: null,
  loading: false,
};

const RepositionAccount = ({ account, onComplete }) => {
  const [info, setInfo] = useState(null);
  const { setNotify, closeSettings } = useTheme();
  const { getChartOfAccounts, getAllAccounts } = useAccounts();
  const [state, dispatch] = useReducer(reducer, initialState);

//   console.log("RepositionAccount component mounted with account:", account);

  useEffect(() => {
    if (account) {
      dispatch({ type: 'accountNumber', value: account.account_number });
      dispatch({ type: 'accountTitle', value: account.account_name });
      dispatch({ type: 'accountDescription', value: account.description });
      dispatch({ type: 'isSubAccount', value: account.is_sub_account_of });
      getCategoryAccounts();
    }
  }, [account]);

  useEffect(() => {
    if (info) {
      setTimeout(() => setInfo(null), 5000);
    }
  }, [info]);


 const getCategoryAccounts = async () => {
    dispatch({ type: 'accountListing', value: false });
    const server_response = await ajaxAccountChart.listAccountsForCategory(account.account_category_id);
    if (server_response.status === 'OK') {
        dispatch({ type: 'accountListing', value: server_response.details });
    } else {
        dispatch({ type: 'accountListing', value: '404' });
    }
};

  const handleSave = async (event) => {
    event.preventDefault();
    if (state.loading) return;

    dispatch({ type: 'loading', value: true });

    const server_response = await ajaxAccountChart.changeAccountHierarchy(account.account_id,state.isSubAccount ? state.parentAccount?.value : '0');

    dispatch({ type: 'loading', value: false });

    if (server_response.status === 'OK') {
      setNotify(<Notification type="success" message={server_response.message} />);
      getChartOfAccounts(true);
      getAllAccounts(true);
      closeSettings();
    } else {
      setInfo(<Notification type="danger" message={server_response.message} />);
    }
  };

  const RenderAccountListing = () => {
    const options = [];
    if (state.accountListing && state.accountListing !== '404') {
      state.accountListing.map((item) =>
        options.push({ label: `${item.account_number} ${item.account_name}`, value: item.account_id })
      );
    }

    return (
      <TextInput
        label="Parent Account"
        type="select"
        leftIcon="fa-solid fa-sitemap"
        placeholder={state.parentAccount.label || 'Select parent account...'}
        options={options}
        onChange={(item) => dispatch({ type: 'parentAccount', value: item })}
        loading={!state.accountListing}
        wrap
      />
    );
  };

  return (
    <div className="card-body">
      <CallOut
        title="Account Hierarchy"
        description="Change the account hierarchy in the chart of accounts. Please make sure the main account has no transactions before reordering."
      />

      {info}

      <form className="form-horizontal" onSubmit={handleSave}>

        {/* Account Info Display */}
        <div className="account-info-block">
          <label className="account-label">Account Number</label>
          <div className="account-value">{state.accountNumber || '-'}</div>
        </div>

        <div className="account-info-block">
          <label className="account-label">Account Title</label>
          <div className="account-value">{state.accountTitle || '-'}</div>
        </div>

        <div className="account-info-block">
          <label className="account-label">Account Description</label>
          <div className="account-value">{state.accountDescription || '-'}</div>
        </div>

        {/* Sub-account Toggle */}
        <div className="form-check mb-3 mt-3">
          <input
            type="checkbox"
            className="form-check-input"
            id="isSubAccount"
            checked={state.isSubAccount}
            onChange={(e) => dispatch({ type: 'isSubAccount', value: e.target.checked })}
          />
          <label className="form-check-label" htmlFor="isSubAccount">
            Is this a sub-account?
          </label>
        </div>

        {/* Parent Account Select */}
        {state.isSubAccount && (
          <div className="account-info-block">
            {RenderAccountListing()}
          </div>
        )}

        <div className="text-right mt-4">
          {!state.loading ? (
            <button type="submit" className="btn btn-lg btn-success">
              Reorder Account
            </button>
          ) : (
            <ActivityLoader />
          )}
        </div>
      </form>

    </div>
  );
};

export default RepositionAccount;
